import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Alert from '@material-ui/lab/Alert';

import {
  makeStyles,
  Button,
  Grid,
  IconButton,
  Box,
  Typography,
} from '@material-ui/core';

import {
  AccountCircle,
  LockRounded,
  AccountBalance,
  Visibility,
  VisibilityOff,
} from '@material-ui/icons';

import {
  showAuthLoader,
  userSignIn,
  showAuthMessage,
  hideMessage,
  clearCaptchaReset,
} from 'actions/Auth';

import publicIp from 'public-ip';
import api from 'services/api2';

import imgFundo from '../assets/images/imagem8.jpg';
import logo from '../assets/images/logo-cobcloud.png';

import Turnstile, { useTurnstile } from 'react-turnstile';

const useStyles = makeStyles((theme) => ({
  inputUpper: {
    textTransform: 'uppercase',
  },
  container: {
    height: '100vh',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: '100vh',
      overflow: 'visible',
    },
  },
  imageSection: {
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#f8f9fa',
    padding: '16px 24px 16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '20px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
  },
  loginSection: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f9fa',
    padding: '16px 24px 16px 16px',
  },
  loginContainer: {
    width: '100%',
    maxWidth: '440px',
    padding: '44px 40px 40px 40px',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
  },
  logo: {
    width: '250px',
    height: 'auto',
    marginBottom: '36px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  welcomeTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1F2937',
    marginBottom: '6px',
    lineHeight: '1.3',
  },
  welcomeSubtitle: {
    fontSize: '14px',
    color: '#9CA3AF',
    marginBottom: '32px',
    fontWeight: '400',
  },
  inputLabel: {
    fontSize: '13px',
    fontWeight: '500',
    color: '#6B7280',
    marginBottom: '8px',
    display: 'block',
  },
  textField: {
    marginBottom: '18px',
  },
  inputRoot: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '12px',
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    padding: '10px 14px',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: '#D1D5DB',
    },
    '&:focus-within': {
      borderColor: '#9CA3AF',
      boxShadow: '0 0 0 1px rgba(156, 163, 175, 0.35)',
    },
  },
  inputRootDisabled: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
  inputIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9CA3AF',
    marginRight: '10px',
  },
  inputDivider: {
    width: '1px',
    alignSelf: 'stretch',
    backgroundColor: '#E5E7EB',
    marginRight: '10px',
  },
  inputContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  inputLabelInside: {
    fontSize: '12px',
    color: '#9CA3AF',
    marginBottom: '2px',
  },
  inputNative: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    fontSize: '14px',
    color: '#1F2937',
    fontWeight: 500,
    padding: 0,
  },
  inputRightIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px',
    color: '#9CA3AF',
  },

  loginButton: {
    backgroundColor: '#FF6B35',
    color: '#ffffff',
    borderRadius: '14px',
    padding: '14px',
    fontSize: '15px',
    fontWeight: '600',
    textTransform: 'uppercase',
    boxShadow: 'none',
    marginBottom: '24px',
    marginTop: '8px',
    '&:hover': {
      backgroundColor: '#FF5722',
      boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
    },
    '&:disabled': {
      backgroundColor: '#D1D5DB',
      color: '#ffffff',
    },
  },

  motivationalBalloon: {
    position: 'absolute',
    top: '40px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(255, 107, 53, 0.9)',
    color: '#ffffff',
    padding: '16px 24px',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(255, 107, 53, 0.35)',
    maxWidth: '380px',
    zIndex: 10,
    animation: '$float 3s ease-in-out infinite',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '30px',
      width: '0',
      height: '0',
      borderLeft: '12px solid transparent',
      borderRight: '12px solid transparent',
      borderTop: '12px solid rgba(255, 107, 53, 0.9)',
    },
  },
  '@keyframes float': {
    '0%, 100%': {
      transform: 'translateX(-50%) translateY(0px)',
    },
    '50%': {
      transform: 'translateX(-50%) translateY(-10px)',
    },
  },
  motivationalText: {
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '1.6',
    margin: 0,
  },
  motivationalBalloon2: {
    position: 'absolute',
    bottom: '40px',
    right: '40px',
    backgroundColor: 'rgba(255, 107, 53, 0.9)',
    color: '#ffffff',
    padding: '16px 24px',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(255, 107, 53, 0.35)',
    maxWidth: '380px',
    zIndex: 10,
    animation: '$floatReverse 3.5s ease-in-out infinite',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-10px',
      right: '30px',
      width: '0',
      height: '0',
      borderLeft: '12px solid transparent',
      borderRight: '12px solid transparent',
      borderBottom: '12px solid rgba(255, 107, 53, 0.9)',
    },
  },
  '@keyframes floatReverse': {
    '0%, 100%': {
      transform: 'translateY(0px)',
    },
    '50%': {
      transform: 'translateY(-8px)',
    },
  },
  motivationalText2: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '1.6',
    margin: 0,
  },
}));

const SignIn = (props) => {
  const classes = useStyles();

  const [mostraConta, setMostraConta] = useState(false);
  const [conta, setConta] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [ip, setIp] = useState('');
  const [tokenCaptcha, setTokenCaptcha] = useState('');

  const [imagemFundo, setImagemFundo] = useState('');
  const [imagemLogo, setImagemLogo] = useState('');

  const [acessoBloqueado, setAcessoBloqueado] = useState(false);

  const [showPasswords, setShowPasswords] = useState({
    showPassword: false,
  });

  const dispatch = useDispatch();
  const turnstile = useTurnstile();

  const { loader, alertMessage, showMessage, authUser, resetCaptcha } =
    useSelector(({ auth }) => auth);

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 3000);
    }

    if (authUser !== null) {
      props.history.push('/');
    }
  }, [showMessage, authUser, props.history, dispatch]);

  useEffect(() => {
    if (resetCaptcha) {
      if (turnstile) {
        setTokenCaptcha('');
        turnstile.reset();
      }
      dispatch(clearCaptchaReset());
    }
  }, [resetCaptcha, dispatch]);

  useEffect(() => {
    const vhost_orig = window.location.hostname;
    let vhost = window.location.hostname;
    vhost = vhost.replace('localhost', '');
    vhost = vhost.replace('.com.br', '');
    vhost = vhost.replace('.cobcloud', '');
    vhost = vhost.replace('app.cob.cloud', '');
    vhost = vhost.replace('app-hml.cob.cloud', '');
    vhost = vhost.replace('app-prod.cob.cloud', '');
    vhost = vhost.replace('.cob.cloud', '');
    vhost = vhost.replace('-novo', '');
    vhost = vhost.replace('-', '');
    vhost = vhost.replace('.', '');
    vhost = vhost.toUpperCase();

    if (
      vhost_orig == 'app.cobcloud.com.br' || // CloudFlare / AWS - Regiao SP A
      vhost_orig == 'app2.cobcloud.com.br' || // CloudFlare / AWS - Regiao SP B
      vhost_orig == 'app.cobcloudapp.com' || // AWS Route53 / Regiao SP B
      vhost_orig == 'app-hml.cobcloudapp.com' || // AWS Route53 / Regiao SP B
      vhost_orig == 'app.cob.cloud' || // GoDaddy - Regiao SP B
      vhost_orig == 'app-hml.cob.cloud' || // GoDaddy - Regiao SP B
      vhost_orig == 'app-prod.cob.cloud' || // ECS prod - dominio provisorio de teste
      vhost_orig == 'hom.cobcloud.com.br' ||
      vhost_orig == 'localhost'
    )
      setMostraConta(true);
    else setMostraConta(false);

    setConta(vhost);
    dadosEmpresa(vhost);

    getIPPublico();
  }, [props.history]);

  async function dadosEmpresa(conta) {
    if (!conta) {
      setImagemFundo(imgFundo);
      setImagemLogo(logo);

      return;
    }

    try {
      const response = await api.get(`/dados_empresa/${conta}`);
      const data = await response.data;

      if (data.length > 0) {
        if (data[0].fundo) setImagemFundo(data[0].fundo);
        else setImagemFundo(imgFundo);

        if (data[0].logo) setImagemLogo(data[0].logo);
        else setImagemLogo(logo);

        if (data[0].status) {
          if (data[0].status == 'INATIVO') {
            setAcessoBloqueado(true);
          }
        }
      } else {
        setImagemFundo(imgFundo);
        setImagemLogo(logo);
      }
    } catch {
      setImagemFundo(imgFundo);
      setImagemLogo(logo);
    }
  }

  async function getIPPublico() {
    try {
      const meuIPPublico = await publicIp.v4();
      setIp(meuIPPublico);
    } catch (error) {
      // console.log('....', error);
    }
  }

  function login() {
    if (conta && username && password) {
      dispatch(showAuthLoader());
      setTimeout(() => {
        dispatch(userSignIn({ conta, username, password, ip, tokenCaptcha }));
      }, 2000);
    } else {
      dispatch(
        showAuthMessage('Todos os campos de preenchimento obrigatório!')
      );
    }
  }

  const handleClickShowPassword = (text) => {
    setShowPasswords({
      ...showPasswords,
      showPassword: !showPasswords.showPassword,
    });
  };

  return (
    <>
      {acessoBloqueado ? (
        <div className="custom-404-bg">
          <div className="custom-404-container">
            <div className="custom-404-code">404</div>

            <h2 className="custom-404-title">Página não encontrada</h2>

            <p className="custom-404-desc">
              O endereço acessado é inválido ou não está disponível.
              <br />
              Caso precise de auxilio, entre em contato com o suporte técnico.
            </p>
          </div>
        </div>
      ) : (
        <Grid container className={classes.container}>
          {/* Imagem de fundo */}
          <Grid item xs={12} md={8} className={classes.imageSection}>
            {/*
        <Box className={classes.motivationalBalloon}>
          <Typography className={classes.motivationalText}>
            2026 começou. Que seja um ano de trabalho bem feito, aprendizado e
            evolução diária. 📈
          </Typography>
        </Box>

        <Box className={classes.motivationalBalloon2}>
          <Typography className={classes.motivationalText2}>
            Que o esforço de hoje vire orgulho pessoal amanhã. E que cada
            vitória profissional ajude a construir uma vida melhor pra você e
            sua família. 😀
          </Typography>
        </Box>
        */}

            <img
              src={imagemFundo}
              alt="background"
              className={classes.backgroundImage}
            />
          </Grid>

          {/* Seção de Login */}
          <Grid item xs={12} md={4} className={classes.loginSection}>
            <Box className={classes.loginContainer}>
              {/* Logo */}
              <img src={imagemLogo} alt="logo" className={classes.logo} />

              {/* Campo Conta */}
              {mostraConta && (
                <Box className={classes.textField}>
                  <Box
                    className={`${classes.inputRoot} ${
                      loader ? classes.inputRootDisabled : ''
                    }`}
                  >
                    <Box className={classes.inputIcon}>
                      <AccountBalance style={{ fontSize: '22px' }} />
                    </Box>
                    <Box className={classes.inputDivider} />
                    <Box className={classes.inputContent}>
                      <span className={classes.inputLabelInside}>Conta</span>
                      <input
                        disabled={loader}
                        maxLength={100}
                        className={`${classes.inputNative} ${classes.inputUpper}`}
                        value={conta}
                        onChange={(e) => setConta(e.target.value)}
                      />
                    </Box>
                  </Box>
                </Box>
              )}

              {/* Campo Usuário */}
              <Box className={classes.textField}>
                <Box
                  className={`${classes.inputRoot} ${
                    loader ? classes.inputRootDisabled : ''
                  }`}
                >
                  <Box className={classes.inputIcon}>
                    <AccountCircle style={{ fontSize: '22px' }} />
                  </Box>
                  <Box className={classes.inputDivider} />
                  <Box className={classes.inputContent}>
                    <span className={classes.inputLabelInside}>Usuário</span>
                    <input
                      disabled={loader}
                      maxLength={100}
                      className={`${classes.inputNative} ${classes.inputUpper}`}
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      onKeyDown={(ev) => {
                        if (ev.key === 'Enter') {
                          login();
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Campo Senha */}
              <Box className={classes.textField}>
                <Box
                  className={`${classes.inputRoot} ${
                    loader ? classes.inputRootDisabled : ''
                  }`}
                >
                  <Box className={classes.inputIcon}>
                    <LockRounded style={{ fontSize: '22px' }} />
                  </Box>
                  <Box className={classes.inputDivider} />
                  <Box className={classes.inputContent}>
                    <span className={classes.inputLabelInside}>Senha</span>
                    <input
                      disabled={loader}
                      maxLength={100}
                      type={showPasswords.showPassword ? 'text' : 'password'}
                      className={classes.inputNative}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(ev) => {
                        if (ev.key === 'Enter') {
                          login();
                        }
                      }}
                    />
                  </Box>
                  <Box className={classes.inputRightIcon}>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                      size="small"
                    >
                      {showPasswords.showPassword ? (
                        <Visibility
                          style={{ fontSize: '22px', color: '#9CA3AF' }}
                        />
                      ) : (
                        <VisibilityOff
                          style={{ fontSize: '22px', color: '#9CA3AF' }}
                        />
                      )}
                    </IconButton>
                  </Box>
                </Box>
              </Box>

              {/* Botão Login */}
              <Button
                onClick={() => login()}
                disabled={loader || !tokenCaptcha}
                variant="contained"
                fullWidth
                className={classes.loginButton}
              >
                {loader || !tokenCaptcha ? (
                  <>
                    <i className="zmdi zmdi-refresh zmdi-hc-fw zmdi-hc-spin mr-2" />
                    <span>Aguarde...</span>
                  </>
                ) : (
                  <span>Acessar</span>
                )}
              </Button>

              {/* Captcha */}
              <Box mb={2}>
                <Turnstile
                  sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                  theme="light"
                  size="flexible"
                  onVerify={(token) => {
                    setTokenCaptcha(token);
                  }}
                  onSuccess={(token) => {
                    //console.log(`on success ${token}`);
                  }}
                  onError={(error) => {
                    console.error('Erro Captcha', error);
                  }}
                  onExpire={() => {
                    setTokenCaptcha('');
                  }}
                />
              </Box>

              {/* Mensagem de erro */}
              {showMessage && (
                <Alert severity="error" style={{ marginBottom: '16px' }}>
                  {typeof alertMessage === 'string'
                    ? alertMessage
                    : (alertMessage && alertMessage.message) ||
                      String(alertMessage)}
                </Alert>
              )}
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SignIn;
